import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA,
  MatSnackBar
} from '@angular/material';
import { TripService } from '../../../services/trip/trip.service';
import { MessagesService } from '../../../services/messages/messages.service';
import { DatePipe } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ScheduletripmodalComponent } from '../scheduletripmodal/scheduletripmodal.component';
import { NgxDateRangePickerOptions } from '../../../../ngx-daterangepicker';

@Component({
  selector: 'app-scheduletriptable',
  templateUrl: './scheduletriptable.component.html',
  styleUrls: ['./scheduletriptable.component.scss']
})


export class ScheduletriptableComponent implements OnInit {

  columnsToDisplay = [
    'zone',
    'tripName',
    'scheduledDate',
    'origin',
    'destination',
    'orders',
    'vehicleDetails',
    'transporter',
    'driverDetails',
    'capacityUtilization'
  ];
  tripsDataArray = new MatTableDataSource<tripListElement>();
  isZoneFiltered: boolean = false;
  zoneFilteredArray = [];
  zones = [];

  //if date is filtered assgin filtered data to new array for zone filtering
  isDateFiltered: boolean = false;
  dateFilteredArray = [];
  selectedValue: string; // selected zone for filter date
  selectedDate: string; //for filter date
  newdupzone = [];
  trips: any;
  daterRangevalue: any;
  options: NgxDateRangePickerOptions;
  isFiltered: boolean = false;
  fromDate: any;
  toDate: any;
  scheduledCount: number = 0;
  page: number = 0;
  totalRecords: Number;
  typeOfTrip: string;
  prevFromDate: any;
  prevTodate: any;
  prevZone: string = null;
  isLoading: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public tripService: TripService,
    public messagesService: MessagesService,
    public datePipe: DatePipe,
    public snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    let date, last, day, month, year;
    this.dialog.closeAll();
     this.typeOfTrip = "TRIP_STATE_SCHEDULED";
     this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
     this.fromDate =  this.datePipe.transform(new Date(), 'yyyy-MM-dd');
     this.setDatePickerToCurrentDate();
     this.findSelectedDateTrips();
  }

  findZoneForPage(res){
    this.zones=[];
    res.forEach(trip => {
      if(trip.tripZone)
        this.zones.push(trip.tripZone);
    });
    this.zones = this.zones.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    })
  }

  findSelectedDateTrips() {
    console.log(this.fromDate);
    this.tripsDataArray.data = [];
    this.isLoading = true;
    this.getData(this.typeOfTrip, this.fromDate, this.toDate).subscribe(inPlanningTripList => {
      this.isLoading = false;
      if (inPlanningTripList.content.length === 0) {
        this.tripsDataArray.data = [];
        this.totalRecords = 0;
        this.page = 0;
        this.paginator.pageIndex = 0;
        this.zones = [];
      }
      else {
        console.log("Inplanning trips",inPlanningTripList);
        this.trips = inPlanningTripList.content;
        this.tripsDataArray.data = inPlanningTripList.content;
       // this.findCustomerZonesForTrip(inPlanningTripList.content);
        this.totalRecords = inPlanningTripList.totalElements;
        console.log('total records', this.totalRecords);
        this.findZoneForPage(inPlanningTripList.content);
      }
    },Error=>{
      this.isLoading = false;
    });
  }

  getData(type, from, to) {
    return this.tripService.getAllTripsByTypesDateRange(type, this.page, from, to, 'nozone');
  }


  pageChanged(event) {
    this.page = event.pageIndex;
    this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
    this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);
    this.findSelectedDateTrips();
  }

  sortByZone() {
    console.log(this.selectedValue);
    this.isZoneFiltered = true;
    let newres = [];
    for (let i = 0; i < this.trips.length; i++) {
      let tripzone = this.trips[i].tripZone;
        if (tripzone === this.selectedValue) 
          newres.push(this.trips[i]);       
        this.tripsDataArray.data = newres;
        this.totalRecords = newres.length;
  }
}

  
 sortByDate() {
  if (this.isDateFiltered && this.page > 0) {
    this.page = 0;
    this.paginator.pageIndex = 0;
  }
  console.log(this.daterRangevalue,this.selectedValue);
  if (this.selectedValue  && !this.daterRangevalue) {
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.findSelectedDateTrips();
    this.prevFromDate = this.fromDate;
    this.prevTodate = this.toDate;
    this.prevZone = this.selectedValue;
  }

  else if (this.daterRangevalue) {
    this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
    this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);

    //call the function only if todate or fromdate or zone value changes 
    if (this.toDate != this.prevTodate || this.fromDate != this.prevFromDate || this.selectedValue != this.prevZone) {
      this.isDateFiltered = true;
      this.findSelectedDateTrips();
      this.prevFromDate = this.fromDate;
      this.prevTodate = this.toDate;
      this.prevZone = this.selectedValue;
    }
  }
}

  setDatePickerToCurrentDate() {
    this.options = {
      theme: 'default',
      labels: ['Start', 'End'],
      menu: null,
      dateFormat: 'YYYY-MM-DD',
      outputFormat: 'DD-MM-YYYY',
      startOfWeek: 1,
      outputType: 'object',
      locale: 'en',
      date: {
        from: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        },
        to: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        }
      }
    };
  }

  clearAllFilter() {
    this.zones = [];
    this.isDateFiltered = false;
    this.isZoneFiltered = false;
    this.selectedValue = "nozone";
    this.setDatePickerToCurrentDate();
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.page = 0;
    this.paginator.pageIndex = 0;
    this.findSelectedDateTrips();
  }

  openSnackBar(message) {
    this.snackBar.open(message, 'X', {
      duration: 10000,
      panelClass: ['extraClasses']
    })
  }

  scheduleTripModal(data) {
    let dialogRef = this.dialog.open(ScheduletripmodalComponent, {
      width: '800px',
      data: { data: data },
      id: 'scheduleTripModal'
    });
    dialogRef.updatePosition({
      top: '50px', right: '0px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
      this.findSelectedDateTrips();
      }
    });
  }

}

export interface tripListElement {
  zone: String,
  tripName: string;
  tripPlannedStartDateTime: String;
  origin: string;
  destination: string;
  orders: string;
  transporter: string;
  vehicleDetails: string;
  driverDetails: string;
  capacityUtilization: string;
}